module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"FinMyPortfolios":{"creation_successful_msg":"Das Portfolio {name} wurde erfolgreich erstellt."}},"en":{"FinMyPortfolios":{"creation_successful_msg":"The portfolio {name} has been successfully created."}}}')
  delete Component.options._Ctor
}
